export const CHART_COLLAPSED_KEY = 'v2-chart-collapsed';
export const CHART_POSITION_KEY = 'v2-chart-position';
export const SUMMARY_COLLAPSED_KEY = 'v2-summary-collapsed';

export type ChartPosition = 'top' | 'bottom';

export function readChartPrefs() {
  try {
    return {
      collapsed: localStorage.getItem(CHART_COLLAPSED_KEY) === '1',
      position: (localStorage.getItem(CHART_POSITION_KEY) === 'top'
        ? 'top'
        : 'bottom') as ChartPosition,
    };
  } catch {
    return { collapsed: false, position: 'bottom' as ChartPosition };
  }
}

export function readSummaryPrefs() {
  try {
    return {
      collapsed: localStorage.getItem(SUMMARY_COLLAPSED_KEY) === '1',
    };
  } catch {
    return { collapsed: false };
  }
}
